import { useAuthenticator } from '@aws-amplify/ui-react';
import { Navigate, useLocation } from 'react-router-dom';

export const AuthWrapper = ({ children }) => {
  const { authStatus } = useAuthenticator(context => [context.authStatus]);
  const location = useLocation();

  if (authStatus === 'configuring') {
    return <div>Loading...</div>;
  }

  if (authStatus !== 'authenticated') {
    return <Navigate to="/home" state={{ from: location }} replace />;
  }

  return children;
};